(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["state-heritage-product"]) return;
  try {
    
  if (!customElements.get('de-keychain')) {
    customElements.define('de-keychain', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.variants = JSON.parse(this.querySelector('[data-variants]').textContent);
        this.labels = JSON.parse(this.querySelector('[data-labels]').textContent);
        this.selects = [...this.querySelectorAll('[data-option]')];
        const initial = this.variants.find(v => String(v.id) === this.dataset.initial) || this.variants[0];
        if (!initial) return;
        this.selects.forEach((select, index) => {
          select.dataset.wanted = initial.options[index];
          select.addEventListener('change', () => this.render(index));
        });
        this.render(-1);
        this.querySelector('[data-selectors]').hidden = false;
        this.querySelector('form').addEventListener('submit', event => {
          if (!this.current || !this.current.available || /coming soon/i.test(this.current.title)) event.preventDefault();
        });
      }
      render(changed) {
        let candidates = this.variants;
        this.selects.forEach((select, index) => {
          const wanted = changed === -1 ? select.dataset.wanted : select.value;
          const values = [...new Set(candidates.map(v => v.options[index]))];
          select.replaceChildren(...values.map(value => new Option(value, value)));
          select.value = values.includes(wanted) ? wanted : values[0];
          candidates = candidates.filter(v => v.options[index] === select.value);
        });
        const variant = candidates[0];
        this.current = variant;
        const soon = /coming soon/i.test(variant.title) || (!variant.available && variant.options[2] === 'Acrylic');
        this.querySelector('[data-variant]').value = variant.id;
        const container = this.querySelector('[data-image]');
        container.replaceChildren();
        const image = variant.featured_image;
        this.querySelector('[data-preview]').hidden = !!image;
        if (image) {
          const img = document.createElement('img');
          img.src = image.src;
          img.alt = variant.title;
          if (image.width) img.width = image.width;
          if (image.height) img.height = image.height;
          container.append(img);
        }
        this.querySelector('[data-price]').textContent = soon ? '' : new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency',currency:this.dataset.currency || 'USD'}).format(variant.price / 100);
        this.querySelector('[data-status]').textContent = soon ? this.labels.soon : variant.available ? '' : this.labels.sold;
        const button = this.querySelector('[data-add]');
        button.disabled = soon || !variant.available;
        button.textContent = soon ? this.labels.soon : variant.available ? this.labels.add : this.labels.sold;
        if (changed !== -1) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          history.replaceState({}, '', url);
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wholesale-halo"]) return;
  try {
    
  if (!customElements.get('de-wholesale')) customElements.define('de-wholesale', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready=true;
      this.labels=JSON.parse(this.querySelector('[data-labels]').textContent);
      this.querySelector('.de-wholesale__planner').hidden=false;
      this.querySelector('[data-build]').addEventListener('click',()=>this.build());
      this.querySelector('[data-count]').addEventListener('input',()=>{
        this.querySelector('[data-order]').disabled=true;
        this.querySelector('[data-error]').textContent=this.labels.apply;
        this.querySelector('[data-groups]').hidden=true;
        this.querySelector('.de-wholesale__total').hidden=true;
      });
      this.querySelector('[data-order]').addEventListener('click',()=>this.order());
      this.build();
    }
    async order(){
      if(this.busy || Number(this.querySelector('[data-count]').value)!==this.quantity)return;
      this.total();if(!this.valid)return;
      this.busy=true;this.querySelector('[data-order]').disabled=true;
      const batch=crypto.randomUUID(),items=[],customs=new Map();
      [...this.querySelector('[data-groups]').children].forEach((group,index)=>{
        const size=Number(group.dataset.size),properties={'Wholesale order':batch,'Case / group':String(index+1),'Glass count':String(size)};
        let i=0;
        for(const row of group._rows){
          if(!row.units)continue;
          const name=row.design==='custom'?row.custom.trim():row.design;
          properties['Design '+(++i)]=`${row.units} × ${row.design==='custom'?'Custom: ':''}${name}`;
          if(row.design==='custom')customs.set(name.replace(/\s+/g,' ').toLocaleLowerCase('en-US'),name);
        }
        items.push({id:Number(size===36?this.dataset.case:this.dataset.single),quantity:size===36?1:size,properties});
      });
      for(const name of customs.values())items.push({id:Number(this.dataset.fee),quantity:1,properties:{'Wholesale order':batch,'Custom design':name}});
      try{
        const response=await fetch(this.dataset.root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items})});
        const result=await response.json();if(!response.ok)throw new Error(result.description||this.labels.failed);
        window.location.assign(this.dataset.root+'cart');
      }catch(error){this.querySelector('[data-error]').textContent=error.message||this.labels.failed;this.busy=false;this.total();}
    }
    money(cents){return new Intl.NumberFormat('en-US',{style:'currency',currency:'USD'}).format(cents/100)}
    build(){
      const quantity=Number(this.querySelector('[data-count]').value);
      const error=this.querySelector('[data-error]');
      if(!Number.isSafeInteger(quantity)||quantity<12){this.querySelector('[data-order]').disabled=true;error.textContent=this.labels.minimum;return}
      const groups=this.querySelector('[data-groups]');
      const previous=[...groups.children].map(g=>g._rows||[]);
      groups.replaceChildren();groups.hidden=false;
      this.querySelector('.de-wholesale__total').hidden=false;
      error.textContent='';this.quantity=quantity;
      const cases=Math.floor(quantity/36),remainder=quantity%36;
      const count=cases+(remainder?1:0);
      for(let index=0;index<count;index++){
        const size=index<cases?36:remainder;
        const group=document.createElement('details');
        group.dataset.size=size;group.open=index===0;
        const summary=document.createElement('summary');
        summary.textContent=(index<cases?`${this.labels.case} ${index+1}`:this.labels.extra)+` — ${size}`;
        group.append(summary);
        const note=document.createElement('p');note.textContent=this.labels.mix;group.append(note);
        const status=document.createElement('p');status.dataset.allocation='';group.append(status);
        group._rows=previous[index]?.length?previous[index]:Array.from({length:6},(_,i)=>({design:'Horizon',units:i===0?size:0,custom:''}));
        const render=()=>{
          if(group.dataset.loaded)return;group.dataset.loaded='true';
          group._rows.forEach((data,i)=>{
            const row=this.querySelector('[data-row-template]').content.firstElementChild.cloneNode(true);
            const select=row.querySelector('[data-design]'),units=row.querySelector('[data-units]'),custom=row.querySelector('[data-custom]');
            select.value=data.design;units.value=data.units;units.max=size;custom.value=data.custom;
            row.querySelector('[data-custom-wrap]').hidden=select.value!=='custom';
            row.addEventListener('input',()=>{
              group._rows[i]={design:select.value,units:Number(units.value),custom:custom.value.trim()};
              row.querySelector('[data-custom-wrap]').hidden=select.value!=='custom';this.total();
            });group.append(row);
          });
        };
        group.addEventListener('toggle',()=>{if(group.open)render()});groups.append(group);if(group.open)render();
      }
      this.total();
    }
    total(){
      const customs=new Set();let valid=true;
      for(const group of this.querySelector('[data-groups]').children){
        let sum=0;let good=true;
        for(const row of group._rows){
          if(!Number.isSafeInteger(row.units)||row.units<0){good=false;continue}
          sum+=row.units;
          if(row.units>0&&row.design==='custom'){
            if(!row.custom.trim())good=false;
            else customs.add(row.custom.trim().replace(/\s+/g,' ').toLocaleLowerCase('en-US'));
          }
        }
        good=good&&sum===Number(group.dataset.size);valid=valid&&good;
        group.querySelector('[data-allocation]').textContent=`${this.labels.allocated}: ${sum} / ${group.dataset.size}`;
      }
      const cases=Math.floor(this.quantity/36),loose=this.quantity%36;
      const glass=cases*60000+loose*1750,fees=customs.size*3500;
      this.querySelector('[data-glasses]').textContent=`${this.labels.glassTotal}: ${cases} × $600 + ${loose} × $17.50 = ${this.money(glass)}`;
      this.querySelector('[data-fees]').textContent=`${this.labels.feeTotal}: ${customs.size} × $35 = ${this.money(fees)}`;
      this.querySelector('[data-total]').textContent=`${this.labels.total}: ${this.money(glass+fees)}`;
      this.querySelector('[data-valid]').textContent=valid?this.labels.valid:this.labels.invalid;
      this.valid=valid;this.querySelector('[data-order]').disabled=!valid || !!this.busy;
    }
  });

  } catch(e) { console.error(e); }
})();
})();
